import { render, staticRenderFns } from "./userAgreement2.0-EN.vue?vue&type=template&id=ed47b57e&scoped=true&"
import script from "./userAgreement2.0-EN.vue?vue&type=script&lang=js&"
export * from "./userAgreement2.0-EN.vue?vue&type=script&lang=js&"
import style0 from "./userAgreement2.0-EN.vue?vue&type=style&index=0&id=ed47b57e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed47b57e",
  null
  
)

export default component.exports